import React, { FC }            from "react";
import { useDispatch }          from "react-redux";
import { Card, Checkbox, Form } from "semantic-ui-react";
import CustomerRecordRepository from "../../../../../domain/record/customer/CustomerRecordRepository";
import CustomerRecordWidget     from "../../../../../domain/record/customer/widget/CustomerRecordWidget";
import CustomerRecordWidgetItem from "../../../../../domain/record/customer/widget/item/CustomerRecordWidgetItem";
import WidgetItemValue          from "../../../../../domain/record/widget/item/WidgetItemValue";
import CustomerRecordDataSource
                                from "../../../../../infrastructure/datasource/record/customer/CustomerRecordDataSource";

interface Props {
  widgetIndex: number;
  widget: CustomerRecordWidget;
}

const CheckVerticalWidget: FC<Props> = (props: Props) => {
  const {widgetIndex, widget} = props;
  const repository: CustomerRecordRepository = new CustomerRecordDataSource(useDispatch());
  return (
    <>
      <div
        style={ {
          position: "absolute",
          left: `${ widget.coordinate.x }px`,
          top: `${ widget.coordinate.y }px`
        } }
        key={ widgetIndex }
      >
        <Card style={ {width: "318px"} }>
          <Card.Content>
            <Form>
              <Form.Field>
                <label>{ widget.title.value }</label>
              </Form.Field>
              {
                widget.items.toList().map((widgetItem, widgetItemIndex) => (
                  <Form.Field>
                    <Checkbox
                      name={ widget.id.toString() }
                      label={ widgetItem.title.value }
                      checked={ widgetItem.value.value === "select" }
                      onClick={ () => repository.setCustomerRecordWidgetItem(widgetIndex, widgetItemIndex, new CustomerRecordWidgetItem(widgetItem.id, widgetItem.widgetItemId, widgetItem.title, new WidgetItemValue("select"))) }
                    />
                  </Form.Field>
                ))
              }
            </Form>
          </Card.Content>
        </Card>
      </div>
    </>
  );
};

export default CheckVerticalWidget;
